module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('mu-content-block', [_c('h1', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("My meal plans")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_vm._v("Browse meal plans generated and saved by you")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "to": "/recipes/generator",
      "label": "Generate meal plan"
    }
  })], 1)]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "align": "left",
      "gutter": ""
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('mu-col', {
      key: 'meal-plan-' + index,
      staticClass: "text-white mealPlan bottom",
      style: ({
        'background': 'url(' + _vm.getImage(item) + ') center center no-repeat no-repeat',
        'backgroundSize': 'cover'
      }),
      attrs: {
        "width": "100",
        "desktop": "50",
        "tablet": "50"
      }
    }, [_c('router-link', {
      staticClass: "text-white",
      attrs: {
        "to": {
          name: 'MealPlanDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "inFront"
    }, [_c('div', [_vm._v("\n            " + _vm._s(item.availableDays.length) + " days\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "recipeTitle"
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "absolutePos",
      style: ({
        'backgroundImage': _vm.generateGradient()
      })
    })])], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-raised-button', {
    staticClass: "full-width",
    attrs: {
      "label": "Load more"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.loadMore.apply(null, arguments)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aad3d25","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Recipes/MealPlans.vue
// module id = 3589
// module chunks = 1